"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { restDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { Button, Spinner } from "@saridana-core/react-ui-kit";
import { ArticleCategory } from "@shared/types";
import { ArticleCard } from "@shared/ui/article-card";
import { transformQueryParams } from "@shared/utils";
import { useInfiniteQuery } from "@tanstack/react-query";
export function Articles(t0) {
  const $ = _c(37);
  const {
    category
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      news: "berita",
      announcement: "pengumuman",
      blog: "blog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const categoryPlaceholder = t1;
  let t2;
  if ($[1] !== category) {
    t2 = async t3 => {
      const {
        pageParam
      } = t3;
      const currentDate = new Date();
      currentDate.setUTCHours(0, 0, 0, 0);
      const url = transformQueryParams("/api/articles", {
        populate: ["image"],
        sort: {
          publishedDate: "desc"
        },
        pagination: {
          start: pageParam,
          limit: 3
        },
        filters: {
          categories: {
            $containsi: category
          },
          $or: [{
            isHighlighted: {
              $eq: false
            }
          }, {
            isHighlighted: {
              $null: true
            }
          }],
          publishedDate: {
            $lte: currentDate.toISOString()
          }
        }
      });
      const res = await restDataProviderClient.custom({
        method: "GET",
        url,
        headers: {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_CMS_TOKEN}`
        },
        options: {
          cache: "no-store"
        }
      });
      return res.data;
    };
    $[1] = category;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const fetchArticles = t2;
  let t3;
  if ($[3] !== category) {
    t3 = ["articles", category];
    $[3] = category;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== fetchArticles || $[6] !== t3) {
    t4 = {
      queryKey: t3,
      initialPageParam: 0,
      queryFn: fetchArticles,
      getNextPageParam: _temp,
      staleTime: 0,
      refetchOnMount: "always"
    };
    $[5] = fetchArticles;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchedAfterMount
  } = useInfiniteQuery(t4);
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== category || $[9] !== data?.pages || $[10] !== isFetchedAfterMount) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const articles = data?.pages.flatMap(_temp2) ?? [];
      if (!isFetchedAfterMount) {
        let t10;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <section className="relative bg-white"><div className="container py-20"><Spinner /></div></section>;
          $[16] = t10;
        } else {
          t10 = $[16];
        }
        t9 = t10;
        break bb0;
      }
      if (!articles?.length && isFetchedAfterMount) {
        const t10 = categoryPlaceholder[category];
        let t11;
        if ($[17] !== t10) {
          t11 = <section className="pt-20 pb-20 sm:pb-[100px] md:pb-[120px] relative bg-white"><div className="container"><div className="text-center flex items-center justify-center text-lg md:text-2xl">Belum ada {t10} yang tersedia untuk saat ini.</div></div></section>;
          $[17] = t10;
          $[18] = t11;
        } else {
          t11 = $[18];
        }
        t9 = t11;
        break bb0;
      }
      t8 = "pt-20 pb-20 sm:pb-[100px] md:pb-[120px] relative bg-white";
      t7 = "container";
      t5 = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[60px] sm:gap-x-6 lg:gap-x-9";
      let t10;
      if ($[19] !== category) {
        t10 = article => <ArticleCard key={article.id} article={article.attributes} category={category} buttonVariant="link" imageClassName="h-[206px] sm:h-[220px] md:h-[240px]" />;
        $[19] = category;
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      t6 = articles.map(t10);
    }
    $[8] = category;
    $[9] = data?.pages;
    $[10] = isFetchedAfterMount;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t6) {
    t10 = <div className={t5}>{t6}</div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== category || $[25] !== fetchNextPage || $[26] !== hasNextPage || $[27] !== isFetching || $[28] !== isFetchingNextPage) {
    t11 = hasNextPage ? <div className="text-center mt-[60px] sm:mt-20"><Button variant="outline" className="text-primary text-lg md:text-xl h-14 md:h-[60px] md:px-8 border-primary hover:text-primary rounded-xl py-4 px-6 font-bold" onClick={() => fetchNextPage()} disabled={isFetchingNextPage || isFetching}>{isFetchingNextPage || isFetching ? "Memuat..." : "Muat Lebih Banyak"}</Button></div> : <div className="p-10 mt-[60px] sm:mt-20 flex items-center justify-center text-center text-gray-500 gap-2"><CheckCircleIcon className="size-5" />Semua {categoryPlaceholder[category]} sudah ditampilkan</div>;
    $[24] = category;
    $[25] = fetchNextPage;
    $[26] = hasNextPage;
    $[27] = isFetching;
    $[28] = isFetchingNextPage;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t7) {
    t12 = <div className={t7}>{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t7;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t8) {
    t13 = <section className={t8}>{t12}</section>;
    $[34] = t12;
    $[35] = t8;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}
function _temp2(p) {
  return p?.data;
}
function _temp(response) {
  const meta = response?.meta.pagination;
  const next = meta.start + meta.limit;
  return next < meta.total ? next : undefined;
}
export function AnnouncementArticles() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Articles category="announcement" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function BlogArticles() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Articles category="blog" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function NewsArticles() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Articles category="news" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}